<template>
  <div>
    <!-- <van-nav-bar title="帮助与反馈" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" /> -->
    <div class="content">

      <div class="problemDescription">
        <div class="text">
          <van-field style="background-color: transparent !important;padding: 0 !important;" readonly>

            <template #label>
              <div style="font-size: 16px;font-weight: 500;letter-spacing: 0px;
                color: rgba(66, 66, 66, 1);
                text-align: left;
                vertical-align: top;">
                问题描述<span style="color: red;">*</span>
              </div>
            </template></van-field>

            <!-- <van-badge dot :offset="[2,4]" >
                <div class="feedback" @click="toFeedback">
                  <span>我的反馈</span>
                </div>
              </van-badge> -->
        </div>
        <van-field style="border-radius: 10px;border-radius: 10px;margin-top: 6px;
          background: rgba(66, 66, 66, 0.05);" :clickable="true" v-model="content" rows="4" autosize type="textarea"
          maxlength="200" placeholder="请填写10个字以上的问题描述以便我们提供更好的帮助" error-message="" />
      </div>

      <div class="picture">
        <div class="text">
          <van-field readonly
            style="background-color: transparent !important;padding-top: 15px;padding-bottom: 0 !important;padding-left: 0 !important;"
            label-width="200">
            <template #label>
              <div style="font-size: 16px;font-weight: 500;   
                color: rgba(66, 66, 66, 1);
                text-align: left;
                vertical-align: top">
                图片（提供问题截图）
              </div>
            </template>
          </van-field>
        </div>
        <div ref="imageUpload" style="background-color: #fff;border-radius: 10px;padding-top: 5px;">
          <van-uploader :upload-icon="upload_icon" style="border-radius: 10px;" :preview-size="imageUpload"
            :before-read="beforeRead" :after-read="afterRead" v-model="fileList" multiple />
        </div>


      </div>


      <div>
        <div class="text">
          <van-field readonly
            style="background-color: transparent !important;padding-top: 15px;padding-bottom: 0 !important;padding-left: 0 !important;"
            label-width="200">
            <template #label>
              <div style="font-size: 16px;font-weight: 500;
color: rgba(66, 66, 66, 1);
text-align: left;
vertical-align: top">
                联系电话<span style="color: red;">*</span>
              </div>
            </template></van-field>
        </div>
        <van-field style=" margin-top: 6px;border-radius: 10px;padding-top: 6px;padding-bottom: 6px;
background: rgba(66, 66, 66, 0.05);" v-model="mobile" placeholder="方便我们与你联系" />
      </div>
      <div style="margin-top: 15px;padding: 10px;padding-left: 0;display: flex;align-items: center;">
        <span style="font-size: 16px;margin-right: 20px;font-weight: 500;
color: rgba(66, 66, 66, 1);
text-align: left;
vertical-align: top">服务评价</span>
        <van-rate size="26" gutter="10" v-model="score" :icon="rate" :void-icon="rate_n" />
      </div>

      <div style="margin-top: 30px;">
        <van-button round block @click="submit" style="font-size: 18px;font-weight: 500;"
          color=" linear-gradient(135deg, rgba(30, 155, 217, 1) 0%, rgba(5, 172, 255, 0.6) 100%)">
          提交
        </van-button>
      </div>

    </div>

  </div>
</template>
<script>
import upload_icon from '@/assets/img/upload_icon.png'
import rate from '@/assets/img/rate.png'
import rate_n from '@/assets/img/rate_n.png'
import { showToast } from 'vant';
import 'vant/es/toast/style';
import axios from 'axios'
import { submitHelp } from '@/api/help'
export default {
  data() {
    return {
      upload_icon: upload_icon,
      rate: rate,
      rate_n: rate_n,
      imageUpload: '100px',
      score: 0,
      mobile: '',
      content: '',
      fileList: [
      ],
      localFileList: [],
      images: [],
      time: new Date(),
      currentDate: new Date(),
      timeShow: false
    }
  },
  mounted() {
    console.log(111);
    this.$nextTick(() => {
      this.imageUpload = (this.$refs.imageUpload.offsetWidth - 24) / 3 + 'px'
    })
  },
  computed: {
    // filterTime() {
    //   const specificDate = new Date(this.time);
    //   const year = specificDate.getFullYear();
    //   const month = String(specificDate.getMonth() + 1).padStart(2, '0');
    //   const day = String(specificDate.getDate()).padStart(2, '0');
    //   const hours = String(specificDate.getHours()).padStart(2, '0');
    //   const minutes = String(specificDate.getMinutes()).padStart(2, '0');
    //   const seconds = String(specificDate.getSeconds()).padStart(2, '0');

    //   const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    //   return formattedDateTime
    // }
  },
  methods: {
    toFeedback(){//去反馈页面
      this.$router.push({
        name:'feedback'
      })
    },
    timeConfig(value) {
      console.log(value);
      this.time = value
      this.timeShow = false
    },
    timeCancel() {
      this.timeShow = false
    },
    selectTime() {
      this.timeShow = true
    },
    submit() {
      let that = this;
      console.log(this.images, '555');
      const data = {
        mobile: this.mobile,
        content: this.content,
        images: this.images.length ? this.images.join(',') : '',
        score: this.score || 0,
      }
      let re = /^((\+|00)86)?1((3[\d])|(4[5,6,7,9])|(5[0-3,5-9])|(6[5-7])|(7[0-8])|(8[\d])|(9[1,2,8,9]))\d{8}$/
      if(!data.mobile || !re.test(data.mobile)){
        showToast({
            message: '请正确填写您的联系电话后再提交',
            position: 'top',
            duration: 2000
          });
          return
      }
      submitHelp(data).then(res => {
        if (res.resultData.code == 200) {
          showToast({
            message: '提交成功',
            position: 'top',
            duration: 1000
          });
          setTimeout(() => {
            console.log('提交成功');
            that.$emit('cloneShowBottom')
            // this.$router.go(-1)
          }, 1000);
        } else {
          showToast({
            message: res.resultData.msg,
            position: 'top',
            duration: 2000
          });
        }
      })
    },
    // upload() {
    //   const formData = new FormData();

    //   try {
    //     this.localFileList.forEach((file, index) => {
    //       //清空formData
    //       formData.delete('file');
    //       formData.append('file', file);
    //       axios.post(import.meta.env.VITE_UPLOAD_PATH, formData, {
    //         headers: {
    //           'Content-Type': 'multipart/form-data',
    //         }
    //       }).then(res => {
    //         if (res.data.code == 200) {
    //           this.images.push(res.data.data)
    //         } else {
    //           console.log(res.data.msg);
    //           showToast({
    //             message: res.data.msg,
    //             position: 'top',
    //           });
    //         }
    //         Promise.resolve(res.data.data)
    //       })
    //         .catch(err => {
    //           console.log(err);
    //           showToast({
    //             message: err,
    //             position: 'top',
    //           });
    //           Promise.reject(err)
    //         })
    //     });

    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    afterRead(val) {
      console.log(111);
      console.log(val,this.fileList,'fileLisr');
      // this.localFileList.push(val.file);
      var formData = new FormData();
      formData.append('file', val.file);
      try {
        // console.log(process.env, 'process.env');
        val.status = 'uploading';
        val.message = '上传中...';
        var _this = this;
        //multipartFile是所传文件流的key，val.file是文件流

        axios.post(import.meta.env.VITE_UPLOAD_PATH, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }).then(res => {
          this.loadingbut = false;
          this.loadingbuttext = '保 存';
          if (res.data.code == 200) {
            console.log(res.data.data);
            val.message = '上传成功';
            val.status = 'success';
            this.images.push(res.data.data.file_path)
          } else {
            showToast({
              message: res.data.msg,
              position: 'top',
              duration: 2000
            });
            val.status = 'failed';
            val.message = '上传失败';
          }
        })
      } catch (error) {
        console.log(error, 'err');
      }
    },
    beforeRead(file) {


      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        showToast({
          message: '请上传jpg或png格式图片',
          position: 'top',
          duration: 2000
        });
        return false;
      }
      return true;
    },
  }
};
</script>

<style>
.van-icon__image {
  width: 100% !important;
  height: 100% !important;
}
</style>
<style>
body,
html {
  min-height: 100%;
}

* {
  margin: 0;
  padding: 0;
}

:root{
  --van-badge-dot-size:5px;
}
</style>
<style lang='scss' scoped>
.content {
  margin-top: 15px;
  padding: 15px 5%;
  padding-top: 0;
  height: 100%;
  // border-radius: 10px;
  .problemDescription{
    .text{
      display: flex;
      .feedback{
        width: 64px;
        font-size: 16px;
        line-height: 23.17px;
        color: rgba(42, 130, 228, 1);
        text-align: right;
        vertical-align: top;
      }
    }
  }

}
</style>